import React from 'react'
import './ourexperience.scss'
import { images } from "../../../utils/customFn";
import { Row, Col} from 'react-bootstrap';
const OurExperience = () => {
    return (
        <>
            <div className='our-experience-banner'>
                <Row className='g-0'>
                    <Col sm={12} md={6} lg={4} xl={4}>
                        <div className='left-img'>
                            <img src={images['why-sentry-our-experience.avif']} alt="img" />
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={8} xl={8}>
                        <div className='right-details'>
                            <h2>Our experience</h2>
                            <p>Back in 1904, members of the Wisconsin Retail Hardware Association gave us our start when they formed their own mutual insurance company. We’ve grown far beyond the hardware industry in the years since. We’ve been providing peace of mind to business owners like you for more than 120 years.</p>
                            <p>At Sentry, we believe great wisdom comes from expert conversations. That’s why we engage our customers in substantial conversations. We listen to their unique challenges and their goals. Then we work with them to identify solutions and plan for the future.</p>
                            <p>We can put our experience to work for you.</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default OurExperience